<template>
  <v-alert
    class="em-alert py-1"
    v-bind="$attrs"
    :class="position"
    :dense="dense"
  >
    <slot />
  </v-alert>
</template>
<script setup>
defineProps({
  position: {
    type: String,
    default: ''
  },
  dense: {
    type: Boolean,
    default: true
  }
})
</script>
<style lang="scss" scoped>
.em-alert {
  display: flex;
  :deep(.v-alert__prepend) {
    align-self: center !important;
  }
  :deep(.v-alert__content) {
    padding: 10px;
  }
  :deep(.v-alert__close) {
    align-self: center !important;
  }
}
</style>
